import React from "react";
import "./styles.less";
import classnames from "classnames";

export const Button = (props) => {
  // size = "medium"
  const { children, mode, onClick, style = {}, className, disabled } = props;
  const cls = classnames({
    "authing-button": true,
    light: mode === "light",
    middleLight: mode === "middleLight",
    disabled,
    [className]: !!className,
  });
  return (
    <button className={cls} {...{ onClick, style, disabled }}>
      {children}
    </button>
  );
};
